<template>
  <v-breadcrumbs
    :items="filteredBreadcrumbs"
    class="crumbs mt-0 ml-0 pt-0 pb-3 px-0"
  />
</template>
<script>
import { mapGetters } from 'vuex'
import HipotekaMap from '../../hipoteka/hipotekaMap'

export default {
  name: 'SavBreadcrumbs',
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'objektasID',
      'hipotekaTipas',
      'savitarnaBreadcrumbs',
      'prasymasID',
      'pazymaID',
    ]),
    filteredBreadcrumbs() {
      return this.savitarnaBreadcrumbs.concat(
        this.breadcrumbs.filter(item => {
          if (item.text !== 'undefined' && item.text !== this.$t('Pradžia')) {
            return item ?? ''
          }
        })
      )
    },
    breadcrumbs() {
      const { matched } = this.$route
      return matched
        .filter(route => {
          return !route.meta.hidePath
        })
        .map((route, index) => {
          let to =
            index === matched.length - 1
              ? this.$route.path
              : route.path || route.redirect
          let text = this.$vuetify.lang.t('' + route.meta.title)
          to = this.checkVariables(to)
          text = this.checkVariables(text)
          return {
            text: text,
            to: to,
            exact: false,
            disabled: false,
          }
        })
    },
    hipotekaTitle() {
      return this.hipotekaTipas
        ? HipotekaMap['hipotekaTipas'][this.hipotekaTipas].title
        : ''
    },
    turtasTitle() {
      const key = Object.keys(HipotekaMap['turtasTekstas']).find(e =>
        this.hipotekaTipas.includes(e)
      )
      return key ? HipotekaMap['turtasTekstas'][key].title : null
    },
    prievoleTitle() {
      const key = Object.keys(HipotekaMap['prievoleTekstas']).find(e =>
        this.hipotekaTipas.includes(e)
      )
      return key ? HipotekaMap['prievoleTekstas'][key].tab : null
    },
    salyginisTitle() {
      const key = Object.keys(HipotekaMap['salyginisTekstas']).find(e =>
        this.hipotekaTipas.includes(e)
      )
      return key ? HipotekaMap['salyginisTekstas'][key].tab : null
    },
  },
  methods: {
    checkVariables(text) {
      if (typeof text !== 'string') {
        return text
      }
      text = text.replace(':objektasID', this.objektasID)
      text = text.replace(':hipotekaTipas', this.hipotekaTitle)
      text = text.replace(':turtasTitle', this.turtasTitle)
      text = text.replace(':prievoleTitle', this.prievoleTitle)
      text = text.replace(':salyginisTitle', this.salyginisTitle)
      text = text.replace(':prasymasID', this.prasymasID)
      text = text.replace(':pazymaID', this.pazymaID)
      return text === 'null' ? '' : text
    },
  },
  created() {},
}
</script>

<style lang="scss">
.crumbs {
  font-family: 'Open Sans';
  font-weight: normal;
  li {
    font-size: 12px !important;
  }
}
</style>
